import { BenefitDto } from 'theSource/queries';
import {
  TOP_BENEFITS_LOOKUP_CODE,
  DECLINE_COVERAGE_LOOKUP_CODE,
} from './constants';

export const parseCoreThreeBenefits = (benefits: BenefitDto[]) => {
  if (benefits.length === 0) {
    return [];
  }

  return benefits.filter(
    (benefit) =>
      TOP_BENEFITS_LOOKUP_CODE.includes(benefit.benefit_lookup_code) &&
      benefit.coverage.req_coverage_level_lookup_code !==
        DECLINE_COVERAGE_LOOKUP_CODE
  );
};
